import React from 'react'
import FormView from '../../common/CommonComponents/FormView';
import { FileCopy } from '@material-ui/icons';
export default function LlmDetails({
    show,
    title,
    width,
    height,
    setShow,
    data
}) {
    const openAiData = data;
    //copy test
    const copyText = (cpId, text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                const copyDsp = document.querySelectorAll('.gw-copydsp');
                copyDsp.forEach(elem => {
                    elem.style.display = 'none'
                });
                const dspCopy = document.getElementById(cpId)
                dspCopy.style.display = 'block';
                setTimeout(() => {
                    dspCopy.style.display = 'none';
                }, 3000);
            })
            .catch(err => {
                console.error('Failed to copy key:', err);
            });
    }
    
    const visible       = show || false;
    const titleText     = title || "Welcome";
    const dspWidth      = width || "600px";
    const dspHeight     = height || "80%";
    const setVisble     = setShow || null;
    
    return (
        <FormView show={visible} title={titleText} width={dspWidth} height={dspHeight} setShow={setVisble}>
            <div style={{ padding: '10px 20px', fontSize: '9px !important' }}>
                <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
                    <span style={{ color: '#7500C0', fontWeight: 'bold' }}>OpenAIServiceName</span>
                    <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '10px', borderRadius: '4px' }}>
                        <span style={{ fontSize: '1rem !important', }}>{openAiData['OpenAIServiceName']}</span>
                    </div>
                </div>
                <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
                    <span style={{ color: '#7500C0', fontWeight: 'bold' }}>OpenAIEndPoint</span>
                    <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '10px', borderRadius: '4px' }}>
                        <span style={{ fontSize: '1rem !important', }}>{openAiData['OpenAIEndPoint']}</span>
                    </div>
                </div>
                <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
                    <span style={{ color: '#7500C0', fontWeight: 'bold' }}>OpenAIKey</span>
                    <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '10px', borderRadius: '4px', wordBreak: 'break-word' }}>
                        {openAiData['OpenAIKey'] &&
                            <>
                                <span className="key-prefix">{openAiData['OpenAIKey'].substring(0, 7)}</span>
                                <span className="key-mask">••••••••••••••••••••••••••••••••</span>
                                <span className="key-suffix">{openAiData['OpenAIKey'].substring(openAiData['OpenAIKey'].length - 4)}</span>
                            </>
                        }
                        <>
                            <div className='gw-copydsp' id={'cp01'}><span>Copied</span><div className="tri"></div></div>
                            <button className='gw-copybtn' title="Copy Text" onClick={() => copyText('cp01', openAiData['OpenAIKey'])} style={{ width: '30px', height: '30px', fontSize: '.8rem', verticalAlign: 'middle', margin: '-5px 0 0 10px' }}>
                                <FileCopy style={{ width: '15px' }} />
                            </button>
                        </>
                    </div>
                </div>
                <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
                    <span style={{ color: '#7500C0', fontWeight: 'bold' }}>SPID</span>
                    <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '5px 10px', borderRadius: '4px', wordBreak: 'break-word' }}>
                        {openAiData['SPID'] &&
                            <>
                                <span className="key-prefix">{openAiData['SPID'].substring(0, 7)}</span>
                                <span className="key-mask">••••••••••••••••••••••••••••••••</span>
                                <span className="key-suffix">{openAiData['SPID'].substring(openAiData['SPID'].length - 4)}</span>
                            </>
                        }
                        <>
                            <div className='gw-copydsp' id={'cp02'}><span>Copied</span><div className="tri"></div></div>
                            <button className='gw-copybtn' title="Copy Text" onClick={() => copyText('cp02', openAiData['SPID'])} style={{ width: '30px', height: '30px', fontSize: '.8rem', verticalAlign: 'middle', margin: '-5px 0 0 10px' }}>
                                <FileCopy style={{ width: '15px' }} />
                            </button>
                        </>
                    </div>
                </div>
                <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
                    <span style={{ color: '#7500C0', fontWeight: 'bold' }}>SPSecretKey</span>
                    <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '15px 10px', borderRadius: '4px', fontSize: '1rem !important' }}>
                        {openAiData['SPSecretKey'] &&
                            <>
                                <span className="key-prefix">{openAiData['SPSecretKey'].substring(0, 7)}</span>
                                <span className="key-mask">••••••••••••••••••••••••••••••••</span>
                                <span className="key-suffix">{openAiData['SPSecretKey'].substring(openAiData['SPSecretKey'].length - 4)}</span>
                            </>
                        }
                        <>
                            <div className='gw-copydsp' id={'cp03'}><span>Copied</span><div className="tri"></div></div>
                            <button className='gw-copybtn' title="Copy Text" onClick={() => copyText('cp03', openAiData['SPSecretKey'])} style={{ width: '30px', height: '30px', fontSize: '.8rem', verticalAlign: 'middle', margin: '-5px 0 0 10px' }}>
                                <FileCopy style={{ width: '15px' }} />
                            </button>
                        </>
                    </div>
                </div>
                <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
                    <span style={{ color: '#7500C0', fontWeight: 'bold' }}>Instance IP / URL</span>
                    <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '5px 10px', borderRadius: '4px', whiteSpace: "pre-line" }}>
                        <span style={{ fontSize: '1rem !important', }}>{
                            openAiData['InstanceIP'] && openAiData['InstanceIP'].split(',').join('\n')}</span>
                    </div>
                </div>
                <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
                    <span style={{ color: '#7500C0', fontWeight: 'bold' }}>ClientName</span>
                    <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '5px 10px', borderRadius: '4px' }}>
                        <span style={{ fontSize: '1rem !important', }}>{openAiData['ClientName']}</span>
                    </div>
                </div>
                <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
                    <span style={{ color: '#7500C0', fontWeight: 'bold' }}>CustomerEnterpriseID</span>
                    <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '5px 10px', borderRadius: '4px' }}>
                        <span style={{ fontSize: '1rem !important', }}>{openAiData['CustomerEnterpriseID']}</span>
                    </div>
                </div>
                <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
                    <span style={{ color: '#7500C0', fontWeight: 'bold' }}>Order ID</span>
                    <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '5px 10px', borderRadius: '4px' }}>
                        <span style={{ fontSize: '1rem !important', }}>{openAiData['OrderId']}</span>
                    </div>
                </div>
                <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
                    <span style={{ color: '#7500C0', fontWeight: 'bold' }}>Environment</span>
                    <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '5px 10px', borderRadius: '4px' }}>
                        <span style={{ fontSize: '1rem !important', }}>{openAiData['Environment']}</span>
                    </div>
                </div>
                <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
                    <span style={{ color: '#7500C0', fontWeight: 'bold' }}>Deployment ID</span>
                    <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '5px 10px', borderRadius: '4px' }}>
                        <span style={{ fontSize: '1rem !important', }}>{openAiData['DeploymentID']}</span>
                    </div>
                </div>
                <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
                    <span style={{ color: '#7500C0', fontWeight: 'bold' }}>Deployment Name</span>
                    <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '5px 10px', borderRadius: '4px', whiteSpace: "pre-line" }}>
                        <span style={{ fontSize: '1rem !important', }}>
                            {openAiData['DeploymentName']}
                        </span>
                    </div>
                </div>
            </div>
        </FormView>
    )
}
